// AutomotivePosts.js
import React, { useState, useEffect } from 'react';
import '../styles/AutomotivePostsAll.css';

function AutomotivePosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://n8n.iniai.cloud/webhook/auto-posts', {
      headers: {
        'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch posts');
      return response.json();
    })
    .then(data => {
      // Take only the 5 most recent posts
      const recentPosts = data.slice(0, 5);
      setPosts(recentPosts);
    })
    .catch(error => {
      console.error('Error fetching posts:', error);
      setError('Failed to load posts');
    })
    .finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="loading-state">Loading posts...</div>;
  if (error) return <div className="error-state">{error}</div>;

  return (
    <div className="automotive-posts">
      <div className="posts-table">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Content</th>
              <th>Date</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {posts.map(post => (
              <tr key={post.id}>
                <td className="title-cell" data-label="Title">
                  {post['key trends title']}
                </td>
                <td className="content-cell" data-label="Content">
                  {post['key trends content']}
                </td>
                <td className="date-cell" data-label="Date">
                  {new Date(post['date_added']).toLocaleDateString()}
                </td>
                <td className="source-cell" data-label="Source">
                  <a
                    href={post['source_url']}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="source-link"
                  >
                    {post['source_name']}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AutomotivePosts;